import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable, forkJoin, map } from 'rxjs';

const I18N_BASE_PATH = '/assets/i18n';

export const I18N_NAMESPACES = [
  'purchase',
  'order',
  'product',
  'customer',
  'compliance',
  'crm',
  'membership',
  'donation',
  'communication',
  'admin',
  'loyalty',
  'workshop',
  'consignment',
  'real-estate',
  'team',
  'appointments',
  'finance',
  'agenda',
];

@Injectable({ providedIn: 'root' })
export class MultiHttpTranslateLoader implements TranslateLoader {
  private readonly http = inject(HttpClient);

  getTranslation(lang: string): Observable<TranslationObject> {
    const sources: Observable<TranslationObject>[] = [
      this.http.get<TranslationObject>(`${I18N_BASE_PATH}/${lang}.json`),
      ...I18N_NAMESPACES.map((ns) =>
        this.http.get<TranslationObject>(`${I18N_BASE_PATH}/${lang}/${ns}.json`),
      ),
    ];
    return forkJoin(sources).pipe(
      map((parts) => Object.assign({}, ...parts) as TranslationObject),
    );
  }
}
